(() => {
  const fitStyleId = 'khb-path-text-fit';
  if (!document.getElementById(fitStyleId)) {
    const style = document.createElement('style');
    style.id = fitStyleId;
    style.textContent = `
      .khb-path-card__copy {
        width: 84%;
        max-width: none;
        min-width: 0;
      }

      .khb-path-card__copy h3 {
        max-width: 100%;
        font-size: clamp(24px, 2.15vw, 36px);
        line-height: 1;
        letter-spacing: .01em;
        overflow-wrap: normal;
        word-break: normal;
      }

      .khb-path-card__copy p {
        max-width: 100%;
      }

      @media (max-width: 989px) {
        .khb-path-card__copy {
          width: 78%;
          max-width: none;
        }

        .khb-path-card__copy h3 {
          font-size: clamp(32px, 5.2vw, 46px);
        }
      }

      @media (max-width: 749px) {
        .khb-path-card__copy {
          width: 92%;
          max-width: none;
        }

        .khb-path-card__copy h3 {
          font-size: clamp(24px, 7.2vw, 34px);
          line-height: 1.02;
        }
      }
    `;
    document.head.appendChild(style);
  }

  const headerContrastStyleId = 'khb-header-contrast-fix';
  if (!document.getElementById(headerContrastStyleId)) {
    const style = document.createElement('style');
    style.id = headerContrastStyleId;
    style.textContent = `
      body:has(.khb) .kph {
        position: relative !important;
        z-index: 60 !important;
        background: #ffffff !important;
        color: #071429 !important;
        border-bottom: 1px solid rgba(7, 20, 41, .14) !important;
      }

      body:has(.khb) .kph__bar {
        position: relative !important;
        inset: auto !important;
        background: #ffffff !important;
        color: #071429 !important;
      }

      body:has(.khb) .kph__link,
      body:has(.khb) .kph__summary,
      body:has(.khb) .kph__icon,
      body:has(.khb) .kph__mobile,
      body:has(.khb) .kph__showroom {
        color: #071429 !important;
      }

      body:has(.khb) .kph__brand {
        background: none !important;
      }

      body:has(.khb) .kph__brand img {
        opacity: 1 !important;
      }

      body:has(.khb) .kph__drawer,
      body:has(.khb) .kph__panel {
        background: #ffffff !important;
        color: #071429 !important;
      }

      body:has(.khb) .kph__drawer .kph__link,
      body:has(.khb) .kph__panel a {
        color: #071429 !important;
      }
    `;
    document.head.appendChild(style);
  }

  const header = document.querySelector('.kph');
  if (header) {
    header.open = true;
    const menuButton = header.querySelector('.kph__mobile');
    if (menuButton) {
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.addEventListener('click', (event) => {
        if (!window.matchMedia('(max-width: 980px)').matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        header.open = true;
        const expanded = header.classList.toggle('kph--drawer-open');
        menuButton.setAttribute('aria-expanded', String(expanded));
      }, true);
    }
  }

  document.querySelectorAll('.kph a[href="/pages/home-page"]').forEach((link) => {
    link.setAttribute('href', '/');
  });

  document.querySelectorAll('.kph a[href="/pages/the-vitals-community"]').forEach((link) => {
    link.setAttribute('href', '/pages/vitals-collection');
    link.textContent = 'Vitals Collection';
  });
})();
